import * as React from 'react'
import { ProductModels } from '@getgreenline/products'
import { Menu } from 'antd'
import { ToggleModalType } from './ProductList'

interface Props {
  product: ProductModels.INestedProduct
  toggleModal: (type: ToggleModalType, product: ProductModels.INestedProduct) => void
}

export const EditMenuItem = (props: Props) => {
  const { product } = props
  const { toggleModal, ...menuItemProps } = props

  return (
    <>
      {product.parentProductId && (
        <Menu.Item {...menuItemProps} onClick={() => toggleModal('standalone', product)}>
          Split to standalone
        </Menu.Item>
      )}
      {product.parentProductId && (
        <Menu.Item {...menuItemProps} onClick={() => toggleModal('variant', product)}>
          Split to variant
        </Menu.Item>
      )}
      {!product.isMasterProduct && (
        <Menu.Item {...menuItemProps} onClick={() => toggleModal('merge', product)}>
          Merge
        </Menu.Item>
      )}
      <Menu.Item
        {...menuItemProps}
        className='blaze-text-danger'
        onClick={() => toggleModal('delete', product)}
      >
        Delete
      </Menu.Item>
    </>
  )
}
